/**
 *
 */
export function calcItemsPerPage(
  stageClientWidth: number,
  gap: number,
  cut: number,
  outerGap: number,
): number {
  const maxItemWidth = 312;
  return Math.max(
    1,
    Math.ceil((stageClientWidth - outerGap - maxItemWidth * cut) / (gap + maxItemWidth)),
  );
}
